(async () => {
  const cssPath = '/assets/css/style.css';

  try {
    const response = await fetch(cssPath, { method: 'HEAD' });
    const lastModified = response.headers.get('Last-Modified');

    if (lastModified) {
      const timestamp = new Date(lastModified).getTime(); // UNIXタイムスタンプ

      const linkEls = document.querySelectorAll('link[rel="stylesheet"]');
      for (const linkEl of linkEls) {
        if (linkEl.getAttribute('href') === cssPath) {
          linkEl.href = `${cssPath}?v=${timestamp}`;
          break; // 該当要素が見つかれば終了
        }
      }
    }
  } catch (error) {
    console.error('CSSファイルの更新日時の取得に失敗しました:', error);
  }
})();